const constants = {
    BASE_URL: 'https://testapi.myredfolder.kyybaapps.com/myredfolder/api/',
    REDIRECTION_URL: 'https://www.myredfolder.kyybaapps.com/',

    //ENVIRONMENT: "LOCAL",
    //  ENVIRONMENT: "DEV",
    ENVIRONMENT: "STAGING",
    endPointUrl: {
        "LOCAL": "https://testapi.myredfolder.kyybaapps.com/myredfolder/api/",
        "DEV": "https://developmentapi.myredfolder.kyybaapps.com/myredfolder/api/",
        // "STAGING": "https://stagingapi.myredfolder.kyybaapps.com/myredfolder/api/",
        "STAGING" : "https://testapi.myredfolder.kyybaapps.com/myredfolder/api/"

    },

    launch: {
        TRIAL_LIVE: true,
        TRIAL_URL: "/pricing",
        LIMITED_OFFER_LIVE: false,
        WALMART_OFFER_VERIFIED: false,
    },

    // Homepage "About" video.
    ABOUT_VIDEO_URL: "https://player.vimeo.com/video/1233210971?h=f2c4774667&badge=0&autopause=0&player_id=0&app_id=58479",
    ABOUT_VIDEO_CTA_URL: "https://www.test.myredfolder.kyybaapps.com/create-account",
    ABOUT_VIDEO_CTA_LABEL: "Get Started",
    // Homepage "Our Products" video.
    APP_VIDEO_URL: "https://player.vimeo.com/video/889049214?badge=0&autopause=0&quality_selector=1&player_id=0&app_id=58479",
    // Business and Government explainer video.
    BUSINESS_VIDEO_URL: "https://player.vimeo.com/video/1233875016?h=c5a0db9414",
    GOV_VIDEO_URL: "https://player.vimeo.com/video/1234137207?h=ad160a1ae0",
    // APP Page videos.
    MRF_APP_PODCAST_VIDEO_URL: "https://player.vimeo.com/video/1228926463?h=8304264a5a&title=0&byline=0&portrait=0",
    MRF_APP_TORNADO_VIDEO_URL: "https://player.vimeo.com/video/1228923376?h=246be97ad8&title=0&byline=0&portrait=0",
    MRF_APP_BE_READY_VIDEO_URL: "https://player.vimeo.com/video/1228924524?h=eeea7ef0ac&title=0&byline=0&portrait=0",
}
export default constants;
